module.exports = __webpack_public_path__ + "teqbahn-assets/media/Climate_Logo_horizontal_RGB.039a0a0a.png";